/**
 * Shared constants and types used across the v2 invoice module.
 */

// --- Lifecycle statuses ---

export const LIFECYCLE_STATUS = {
  UPLOADED: "UPLOADED",
  OCR_IN_PROGRESS: "OCR_IN_PROGRESS",
  OCR_COMPLETED: "OCR_COMPLETED",
  OCR_FAILED: "OCR_FAILED",
  GRN_PENDING: "GRN_PENDING",
  GRN_MATCHED: "GRN_MATCHED",
  THREE_WAY_MATCH_PENDING: "THREE_WAY_MATCH_PENDING",
  MATCH_EXCEPTION: "MATCH_EXCEPTION",
  UNDER_REVIEW: "UNDER_REVIEW",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  EXPORT_READY: "EXPORT_READY",
  SENT_TO_D365: "SENT_TO_D365",
  D365_FAILED: "D365_FAILED",
  EXPORTED: "EXPORTED",
  VALIDATION_IN_PROGRESS: "VALIDATION_IN_PROGRESS",
  VALIDATION_SUCCESS: "VALIDATION_SUCCESS",
  VALIDATION_FAILED: "VALIDATION_FAILED",
} as const;

export type LifecycleStatus = (typeof LIFECYCLE_STATUS)[keyof typeof LIFECYCLE_STATUS];

// --- Roles ---

export const ROLE = {
  VENDOR: "VENDOR",
  AP_PROCESSOR: "AP_PROCESSOR",
  VENDOR_MANAGER: "VENDOR_MANAGER",
  AP_MANAGER: "AP_MANAGER",
  FINANCE_CONTROLLER: "FINANCE_CONTROLLER",
} as const;

export type Role = (typeof ROLE)[keyof typeof ROLE];

// --- Shared types ---

export type StatusCounts = Record<string, number>;

/** Returns lifecycle_status if present, otherwise falls back to invoice_status.state or status (for old v1 invoices). */
export function getEffectiveStatus(invoice: {
  lifecycle_status?: string | null;
  status?: string;
  invoice_status?: { label: string; state: string } | null;
}): LifecycleStatus {
  return (invoice.lifecycle_status || invoice.invoice_status?.state || invoice.status) as LifecycleStatus;
}
